import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["value", "disableFormating", "decimalCount", "displayTrailingZeros", "prefix", "suffix", "noSpaceAfterSuffix", "className", "blankDisplay", "zeroIsBlank", "displayOrdinal", "abbreviate", "thousandSeparator", "typographyVariant", "weightVariant", "color", "noWrap", "useNegForEmptyValue"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Typography } from "components/mui";
import { formatNumber } from "utils/numberFormatting";

// Re-export the utility functions for backward compatibility
import { jsxs as _jsxs } from "react/jsx-runtime";
export { convertToOrdinal, abbreviateNumber } from "utils/numberFormatting";
export default function NumberFormater(props) {
  var value = props.value,
    disableFormating = props.disableFormating,
    _props$decimalCount = props.decimalCount,
    decimalCount = _props$decimalCount === void 0 ? 0 : _props$decimalCount,
    displayTrailingZeros = props.displayTrailingZeros,
    prefix = props.prefix,
    suffix = props.suffix,
    _props$noSpaceAfterSu = props.noSpaceAfterSuffix,
    noSpaceAfterSuffix = _props$noSpaceAfterSu === void 0 ? false : _props$noSpaceAfterSu,
    className = props.className,
    _props$blankDisplay = props.blankDisplay,
    blankDisplay = _props$blankDisplay === void 0 ? null : _props$blankDisplay,
    zeroIsBlank = props.zeroIsBlank,
    displayOrdinal = props.displayOrdinal,
    abbreviate = props.abbreviate,
    thousandSeparator = props.thousandSeparator,
    _props$typographyVari = props.typographyVariant,
    typographyVariant = _props$typographyVari === void 0 ? "paragraph_medium" : _props$typographyVari,
    _props$weightVariant = props.weightVariant,
    weightVariant = _props$weightVariant === void 0 ? "inherit" : _props$weightVariant,
    color = props.color,
    noWrap = props.noWrap,
    _props$useNegForEmpty = props.useNegForEmptyValue,
    useNegForEmptyValue = _props$useNegForEmpty === void 0 ? false : _props$useNegForEmpty,
    rest = _objectWithoutProperties(props, _excluded);
  var formattedValue = formatNumber(value, {
    disableFormating: disableFormating,
    decimalCount: decimalCount,
    displayTrailingZeros: displayTrailingZeros,
    prefix: typeof prefix === "string" ? prefix : "",
    suffix: typeof suffix === "string" && suffix && !noSpaceAfterSuffix ? " ".concat(suffix) : typeof suffix === "string" ? suffix : "",
    blankDisplay: blankDisplay || "—",
    zeroIsBlank: zeroIsBlank,
    displayOrdinal: displayOrdinal,
    abbreviate: abbreviate,
    thousandSeparator: thousandSeparator,
    useNegForEmptyValue: useNegForEmptyValue
  });
  var hasReactNodePrefix = prefix && typeof prefix !== "string";
  var hasReactNodeSuffix = suffix && typeof suffix !== "string";
  var isBlank = value == null || zeroIsBlank && value === 0 || isNaN(value);
  return /*#__PURE__*/_jsxs(Typography, _objectSpread(_objectSpread({
    variant: typographyVariant,
    weight: weightVariant,
    className: "number-render ".concat(className || ""),
    color: color,
    noWrap: noWrap
  }, rest), {}, {
    children: [hasReactNodePrefix && prefix, hasReactNodePrefix ? formatNumber(value, {
      disableFormating: disableFormating,
      decimalCount: decimalCount,
      displayTrailingZeros: displayTrailingZeros,
      blankDisplay: blankDisplay || "—",
      zeroIsBlank: zeroIsBlank,
      displayOrdinal: displayOrdinal,
      abbreviate: abbreviate,
      thousandSeparator: thousandSeparator,
      useNegForEmptyValue: useNegForEmptyValue
    }) : formattedValue, hasReactNodeSuffix && !noSpaceAfterSuffix && !isBlank && " ", hasReactNodeSuffix && suffix]
  }));
}